import { RouteUrlList } from '@/libs/RouteList';

/**
 * @todo 基本身份驗證 ViewData
 */
const GetUserAuthViewData = [
    'POST',
    RouteUrlList.API_UserAuthViewData.path,
    {},
    200,
    {
        status: true,
        title: '',
        message: 'OK',
        errorCode: '',
        ssn: 'A123456789',
        countryList: [
            {
                countrycode: 'AF',
                countrytitle: '阿富汗'
            },
            {
                countrycode: 'AL',
                countrytitle: '阿爾巴尼亞'
            },
            {
                countrycode: 'DZ',
                countrytitle: '阿爾及利亞'
            },
            {
                countrycode: 'AS',
                countrytitle: '美屬薩摩亞'
            },
            {
                countrycode: 'AD',
                countrytitle: '安道爾'
            },
            {
                countrycode: 'AO',
                countrytitle: '安哥拉'
            },
            {
                countrycode: 'AI',
                countrytitle: '英屬安圭拉'
            },
            {
                countrycode: 'AQ',
                countrytitle: '南極洲'
            },
            {
                countrycode: 'AG',
                countrytitle: '安地卡及巴布達'
            },
            {
                countrycode: 'AR',
                countrytitle: '阿根廷'
            }
        ]
    }
];
export default GetUserAuthViewData;
